import { REDUX_ACTIONS, GAME_ID, QUESTION_PHASES } from 'a/wordSlide/data/constants';

const initState = {
  itemId: 0,
  target: '',
  audio: '',
  tiles: [],
  targetSelection: [],
  positions: [],
  sizes: [],
  phase: QUESTION_PHASES.DROP_IN,
  shallRunFillCellAnimation: false,
  showIncorrectFill: false,
  showIncorrectBorder: false,
  attempts: 0,
  dropCellIn: -1,
  dropCellOut: -1,
  glowFadeOutNonce: 0,
};

const questionReducer = (state = initState, { type, payload, gameId }) => {
  if (gameId !== GAME_ID) {
    return state;
  }

  switch (type) {
    case REDUX_ACTIONS.SET_QUESTION_DATA:
      return {
        ...initState,
        ...payload,
        sizes: payload.tiles.map(tiles => tiles.length),
        positions: payload.tiles.map(tiles => tiles.length - 1),
        phase: QUESTION_PHASES.DROP_IN,
        shallRunFillCellAnimation: false,
        showIncorrectFill: false,
        showIncorrectBorder: false,
        attempts: 0,
        dropCellIn: -1,
        dropCellOut: -1,
        // event counter, not question data — preserving it avoids a spurious fade on question load
        glowFadeOutNonce: state.glowFadeOutNonce,
      };

    case REDUX_ACTIONS.MOVE_TILE_TO:
      return {
        ...state,
        positions: state.positions.map((pos, i) => (i === payload.i ? payload.pos : pos)),
      };

    case REDUX_ACTIONS.SET_QUESTION_PHASE: {
      const { phase } = payload;
      return {
        ...state,
        phase,
      };
    }

    case REDUX_ACTIONS.SET_SHOW_INCORRECT_FILL:
      return {
        ...state,
        showIncorrectFill: payload.showIncorrectFill,
      };

    case REDUX_ACTIONS.SET_SHOW_INCORRECT_BORDER:
      return {
        ...state,
        showIncorrectBorder: payload.showIncorrectBorder,
      };

    case REDUX_ACTIONS.INCREASE_ATTEMPTS:
      return {
        ...state,
        attempts: state.attempts + 1,
      };

    case REDUX_ACTIONS.DROP_CELL_IN:
      return {
        ...state,
        dropCellIn: payload.cellIndex,
      };

    case REDUX_ACTIONS.DROP_CELL_OUT:
      return {
        ...state,
        dropCellOut: payload.cellIndex,
      };

    case REDUX_ACTIONS.FADE_OUT_GLOW:
      return {
        ...state,
        glowFadeOutNonce: state.glowFadeOutNonce + 1,
      };

    default:
      return state;
  }
};

export default questionReducer;
